import createIcon from '../../createIcon';

/**
 * @component @name ThreegMobiledata
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyA3VjlIOFYxMUg0VjEzSDhWMTVIM1YxN0g4QzkuMSAxNyAxMCAxNi4xIDEwIDE1VjEzLjVDMTAgMTIuNjcgOS4zMyAxMiA4LjUgMTJDOS4zMyAxMiAxMCAxMS4zMyAxMCAxMC41VjlDMTAgNy45IDkuMSA3IDggN0gzWk0yMSAxMVYxNUMyMSAxNi4xIDIwLjEgMTcgMTkgMTdIMTRDMTIuOSAxNyAxMiAxNi4xIDEyIDE1VjlDMTIgNy45IDEyLjkgNyAxNCA3SDE5QzIwLjEgNyAyMSA3LjkgMjEgOUgxNFYxNUgxOVYxM0gxNi41VjExSDIxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ThreegMobiledata = createIcon('ThreegMobiledata', [
  [
    'path',
    {
      d: 'M3 7V9H8V11H4V13H8V15H3V17H8C9.1 17 10 16.1 10 15V13.5C10 12.67 9.33 12 8.5 12C9.33 12 10 11.33 10 10.5V9C10 7.9 9.1 7 8 7H3ZM21 11V15C21 16.1 20.1 17 19 17H14C12.9 17 12 16.1 12 15V9C12 7.9 12.9 7 14 7H19C20.1 7 21 7.9 21 9H14V15H19V13H16.5V11H21Z',
      key: '164o0m',
    },
  ],
]);

export default ThreegMobiledata;
